<template>
  <div class="header">
    <slot name="header">
      <div class="dialog-title-text">
        <span>{{ title }}</span>
      </div>
      <header-buttons :read-article-url="readArticleUrl" />

      <button v-if="closeBtn" class="dialog-close-button" @click="close">
        <ui-icon size="18" :color="$colors.white" icon="fas fa-times" />
      </button>

      <ui-logout
        v-if="logOutBtn"
        :actionBeforeLogout="actionBeforeLogout"
        @close="close"
        class="dialog-logout"
      ></ui-logout>
    </slot>
  </div>
</template>

<script setup lang="ts">
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue';
import UiLogout from '@/components/ui/ui-logout.vue';
import { useColors } from '@/composables';

const $colors = useColors();

withDefaults(
  defineProps<{
    title?: string;
    closeBtn?: boolean;
    logOutBtn?: boolean;
    readArticleUrl?: string;
    actionBeforeLogout?: () => void;
  }>(),
  {
    title: '',
    closeBtn: true,
    logOutBtn: false,
    readArticleUrl: '',
    actionBeforeLogout: () => {},
  },
);

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const close = () => {
  emit('close');
};
</script>
<style scoped lang="scss">
.dialog-close-button {
  width: 51px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-left: 1px solid var(--color-white20);
}

.header {
  background-color: var(--color-bluedark) !important;
  position: relative;
  width: 100%;
  display: flex;
  padding: 14px 50px 14px 24px !important;
  color: var(--color-white) !important;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;

  .close {
    position: absolute;
    right: 0;
  }

  .dialog-title-text {
    padding-right: 10px;
    white-space: nowrap;
    max-width: calc(100% - 230px);

    @media all and (max-width: 600px) {
      max-width: calc(100% - 120px);
    }
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
